import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import ApiService from "../../Core/Service/ApiService";
import LoadingIndicator from "../../Components/LoadingIndicator/LoadingIndicator";
import { MDBBtn, MDBCard, MDBCardBody, MDBCardHeader, MDBCardTitle, MDBCheckbox, MDBCol, MDBIcon, MDBInput, MDBRow, MDBSpinner, MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import { useSelector } from "react-redux";
import { memoizedGetAuthUser } from "../../Store/Reducer/authReducer";
import { useContext } from "react";
import CmsContext from "../../Context/CmsContext";
import Media from "../../Components/CMS/Media";
import ColorPicker from "../../Components/CMS/ColorPicker";
import { CKEditor } from 'ckeditor4-react';
import { toast } from "react-toastify";

const TopRibbonConfig = () => {
    const [formData, setFormData] = useState({
        style: {
            bg_color: '#555',
            txt_color: '#fff',
        },
        content_html: '',
    });
    const formDataRef = useRef(formData);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const cmsContext = useContext(CmsContext);

    useEffect(() => {
        cmsContext.setBreadcrumb([
            { title: 'Site Config'},
            { title: 'Top Ribbon'},
        ])

        setLoading(true);
        ApiService.get('/siteconfig/top_ribbon').then(response => {
            const row = response.data.row;
            if(row) {
                let data = {
                    ...formData,
                    ...row,
                    style: row.style ? JSON.parse(row.style) : formData.style,
                }
    
                setFormData(data);
            }
            setLoaded(true);
        }).finally(() => {
            setLoading(false);   
        })
    }, [])

    useEffect(() => {
        formDataRef.current = {...formData};
    }, [formData]);

    const handleSave = () => {
        const data = {
            ...formData,
            style: JSON.stringify(formData.style),
        };

        setSaving(true);
        ApiService.post('/siteconfig/top_ribbon', data).then(response=>{
            toast.success(response.data.message);
        }).finally(() => {
            setSaving(false);
        })
    }

    const topRibbonStyle = () => {
        return (
        <MDBCard className="top-ribbon-style">
            <MDBCardHeader>
                <MDBCardTitle>Background</MDBCardTitle>
            </MDBCardHeader>
            <MDBCardBody>
                <div className="d-flex">
                    <ColorPicker
                        label="Background Color:"
                        color={formData.style.bg_color}
                        setColor={(color) => setFormData({
                            ...formData,
                            style: {
                                ...formData.style,
                                bg_color: color
                            }
                        })}
                    />
                    <ColorPicker
                        className='ms-4'
                        label="Text Color:"
                        color={formData.style.txt_color}
                        setColor={(color) => setFormData({
                            ...formData,
                            style: {
                                ...formData.style,
                                txt_color: color
                            }
                        })}
                    />
                </div>
            </MDBCardBody>
        </MDBCard>
        )
    }

    const topRibbonContent = () => {
        return (
        <MDBCard className="footer-text mt-4">
            <MDBCardHeader>
                <MDBCardTitle>Content</MDBCardTitle>
            </MDBCardHeader>
            <MDBCardBody>
                {loaded && (
                    <CKEditor
                        initData={formData.content_html}
                        editorUrl="/vendor/ckeditor/ckeditor.js"
                        onInstanceReady={ () => {} }
                        onChange={e => {
                            setFormData({
                                ...formDataRef.current,
                                content_html: e.editor.getData()
                            })
                        }}
                    />
                )}
            </MDBCardBody>
        </MDBCard>
        )
    }

    return (
    <div className="top-ribbon-config">
        { topRibbonStyle() }
        { topRibbonContent() }

        <div className="d-flex justify-content-end mt-4">
            <MDBBtn onClick={handleSave}>
                {saving && <MDBSpinner size="sm" className="me-1" />}
                Save
            </MDBBtn>
        </div>

        <LoadingIndicator show={loading} fullScreen={true} />
    </div>
    )
}

export default TopRibbonConfig;